import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
  signal,
  viewChild,
  DOCUMENT
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  NgForm,
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { ReportIssue } from '@moxi.gmbh/moxi-typescriptmodels';
import { TranslatePipe } from '@ngx-translate/core';
import { sendCommand } from '@shared/data/flux';
import { NotificationService } from '@shared/services';
import { isFormValid } from '@shared/utils';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';

@Component({
  selector: 'moxi-report-issue',
  imports: [
    FormsModule,
    TranslatePipe,
    // Ant Design
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzModalModule,
    NzIconModule
  ],
  templateUrl: './report-issue.component.html',
  styleUrl: './report-issue.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportIssueComponent implements OnInit {
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly document = inject(DOCUMENT);
  private readonly notificationService = inject(NotificationService);

  openModal = signal(false);

  reportIssueForm = new FormGroup({
    issue: new FormControl('', {
      validators: [Validators.required],
      updateOn: 'blur'
    })
  });

  ngForm = viewChild<NgForm>('form');

  ngOnInit(): void {
    this.fb.group(this.reportIssueForm);
  }

  onReportIssueSubmit(): void {
    if (isFormValid(this.reportIssueForm)) {
      const payload = this.reportIssueForm.getRawValue() as ReportIssue;

      sendCommand<string>('com.moxi.api.servicedesk.ReportIssue', {
        ...payload,
        data: {
          url: this.document.location.href
        }
      }).subscribe(() => {
        this.notificationService.success('shared.reportIssue.successMsg');
        this.openModal.set(false);
      });
    }
  }
}
